import { Event } from '../types/api';

// #55: the Invitation row of the "Envoi emails" tab comes from the event stats (whole event,
// computed server-side), never from the page of invitees currently loaded in the Invités tab.
// #60: how many people the "Invitation" send will reach — whole event, from the event stats.
export const invitationPendingCount = (event?: Pick<Event, 'invitation_pending_count'> | null): number =>
  event?.invitation_pending_count ?? 0;

type SendBatch = { emails_sent: number; emails_failed: number; failed_invitee_ids?: number[]; last_invitee_id?: number; remaining?: number; send_log_id?: number | null };

// #60: send to the whole event, server-side, batch by batch. The client never passes invitee ids:
// the server picks the next batch after `after_id`, so failures do not stall the paging.
export async function sendAllPendingInvitations(
  send: (data: { all_pending: true; batch_size: number; after_id: number; send_immediately: true; send_log_id?: number }) => Promise<SendBatch>,
  total: number,
  onProgress?: (p: { sent: number; total: number }) => void,
  batchSize = 10,
  pauseMs = 500
) {
  const results = { success: 0, failed: 0, errors: [] as string[] };
  let afterId = 0;
  let sendLogId: number | undefined; // #56: the whole send is one send-log row
  let done = 0;
  for (let batchNo = 1; ; batchNo++) {
    let response: SendBatch;
    try {
      response = await send({ all_pending: true, batch_size: batchSize, after_id: afterId, send_immediately: true, ...(sendLogId ? { send_log_id: sendLogId } : {}) });
    } catch (error: any) {
      results.errors.push(`Batch ${batchNo}: ${error.message}`);
      break; // cannot know the next cursor: stop rather than resend
    }
    results.success += response.emails_sent;
    results.failed += response.emails_failed;
    if (response.failed_invitee_ids?.length) results.errors.push(`Batch ${batchNo}: ${response.failed_invitee_ids.length} échecs`);
    done += response.emails_sent + response.emails_failed;
    afterId = response.last_invitee_id ?? afterId;
    sendLogId = response.send_log_id ?? sendLogId;
    onProgress?.({ sent: done, total: Math.max(total, done) });
    if (!response.remaining) break;
    if (pauseMs) await new Promise((resolve) => setTimeout(resolve, pauseMs));
  }
  return results;
}
